import { BrowserRouter, Route } from 'react-router-dom';
import Home from './Home';
import withRoot from "./modules/withRoot";

function App() {
	return (
		<BrowserRouter>
			<Route exact path="/" component={Home} />
		</BrowserRouter>
	);
}

export default withRoot(App);